import CustomerTableRow from "./CustomerTableRow";
import NoResultsIndicator from "@/widgets/NoResultsIndicator";
import { getSortIndicator } from "@/lib/tableHelpers";
import { useTranslation } from "react-i18next";

export default function CustomerTable({
  customerData,
  loading,
  selectedCustomers,
  onSelectAll,
  onSelectCustomer,
  isAllSelected,
  isIndeterminate,
  sortColumn,
  sortDirection,
  onSort,
}) {
  const { t } = useTranslation();
  const rows = Array.isArray(customerData) ? customerData : [];

  if (rows.length === 0 && !loading) {
    return <NoResultsIndicator />;
  }

  return (
    <div className="mt-6 overflow-x-auto">
      <table className="min-w-full bg-white border border-gray-300 rounded-lg shadow">
        <thead>
          <tr>
            <th className="py-2 px-4 border-b border-gray-300 text-left w-12">
              <input
                type="checkbox"
                checked={isAllSelected}
                ref={(el) => {
                  if (el) el.indeterminate = isIndeterminate;
                }}
                onChange={(e) => onSelectAll(e.target.checked)}
                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
              />
            </th>
            <th className="py-2 px-4 border-b border-gray-300 text-left">
              <button
                className="flex items-center font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:text-blue-600"
                onClick={() => onSort("name")}
              >
                {t("customers.list.table.name")}
                {getSortIndicator("name", sortColumn, sortDirection)}
              </button>
            </th>
            <th className="py-2 px-4 border-b border-gray-300 text-left">
              <button
                className="flex items-center font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:text-blue-600"
                onClick={() => onSort("email")}
              >
                {t("customers.list.table.email")}
                {getSortIndicator("email", sortColumn, sortDirection)}
              </button>
            </th>
            <th className="py-2 px-4 border-b border-gray-300 text-left">
              <button
                className="flex items-center font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:text-blue-600"
                onClick={() => onSort("tel")}
              >
                {t("customers.list.table.phone")}
                {getSortIndicator("tel", sortColumn, sortDirection)}
              </button>
            </th>
            <th className="py-2 px-4 border-b border-gray-300 text-left">
              <button
                className="flex items-center font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:text-blue-600"
                onClick={() => onSort("created")}
              >
                {t("customers.list.table.created")}
                {getSortIndicator("created", sortColumn, sortDirection)}
              </button>
            </th>
            <th className="py-2 px-4 border-b border-gray-300 text-right w-24">
              <span className="font-semibold text-gray-700">{t("customers.list.table.actions")}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((customer) => (
            <CustomerTableRow
              key={customer._id}
              customer={customer}
              isSelected={selectedCustomers.has(customer._id)}
              onSelectCustomer={onSelectCustomer}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
